import React from 'react';

import { Box, Stack, Text } from '@mantine/core';
import { useModule } from '@/hooks/useModule';
import { PlayIcon } from '@/modules/audio_player/audio_player_module';

interface MiniPlayerProps {
    onExpand: () => void;
    isExpanded: boolean;
}

export function MiniPlayer({ onExpand, isExpanded }: MiniPlayerProps) {
    const audioPlayerModule = useModule('AudioPlayer');
    const playbackStatus = audioPlayerModule.useAudioPlaybackStatus();

    if (!playbackStatus?.fileInfo) {
        return null;
    }

    const songTitle = playbackStatus.fileInfo.name.replace(/\.[^/.]+$/, '');

    return (
        <Box
            onClick={onExpand}
            style={{
                position: 'fixed',
                bottom: 60,
                left: 0,
                right: 0,
                height: 64,
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '8px 12px',
                backgroundColor: 'var(--mantine-color-body)',
                borderTop: '1px solid var(--mantine-color-default-border)',
                cursor: 'pointer',
                zIndex: isExpanded ? 99 : 101,
                pointerEvents: isExpanded ? 'none' : 'auto',
            }}
        >
            <Stack gap={2} style={{ flex: 1, minWidth: 0, paddingLeft: 12 }}>
                <Text
                    size="sm"
                    fw={500}
                    style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {songTitle}
                </Text>
            </Stack>

            {playbackStatus?.fileInfo && (
                <PlayIcon
                    fileInfo={playbackStatus.fileInfo}
                    size={28}
                    style={{ marginRight: 8 }}
                />
            )}
        </Box>
    );
}
